import React from 'react';

import { Badge } from '../../../components/ui/badge';
import { Button } from '../../../components/ui/button';

interface FilaGestoriaProps {
	usuario: { name?: string; email?: string; phone?: string };
	/** Se está enviando la invitación ahora mismo. */
	reenviando: boolean;
	/** Se acaba de enviar y aún no se puede repetir. */
	enEspera: boolean;
	onReenviar: () => void;
	translate: (clave: string) => string;
}

const textoDelBoton = (reenviando: boolean, enEspera: boolean): string => {
	if (reenviando) return 'admin.dashboard.adminSettings.sendingInvite';
	if (enEspera) return 'admin.dashboard.adminSettings.inviteSentSuccess';
	return 'admin.dashboard.adminSettings.resendInvite';
};

/**
 * Una cuenta de gestoría en la Configuración de admin: quién es y el botón de reenviar invitación.
 *
 * 🔴 `flex-wrap`, `min-w-0` y `break-all` no son decorativos. Sin ellos la fila es una sola línea
 * que no puede partirse; con un correo largo mide más que la pantalla de un móvil y, como nada la
 * recorta, ensancha la página entera: cabecera, pestañas y barra inferior salían cortadas.
 */
const FilaGestoria: React.FC<FilaGestoriaProps> = ({
	usuario,
	reenviando,
	enEspera,
	onReenviar,
	translate
}) => (
	<div className="flex flex-wrap items-center justify-between gap-3 p-4 bg-muted/30 rounded-lg">
		<div className="min-w-0">
			<p className="font-medium text-foreground">{usuario.name}</p>
			<p className="text-sm text-muted-foreground break-all">{usuario.email}</p>
			{usuario.phone && <p className="text-sm text-muted-foreground">{usuario.phone}</p>}
		</div>
		<div className="flex flex-wrap items-center gap-2">
			<Button
				variant="outline"
				size="sm"
				onClick={onReenviar}
				disabled={reenviando || enEspera}
				className="rounded-full text-xs"
			>
				{translate(textoDelBoton(reenviando, enEspera))}
			</Button>
			<Badge variant="outline" className="bg-primary/10 text-primary border-primary/20">
				{translate('admin.dashboard.adminSettings.managementAccount')}
			</Badge>
		</div>
	</div>
);

export default FilaGestoria;
